"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
const TabPanel = ({
  className,
  children,
  index,
  active
}) => {
  const classes = (0, _classnames.default)('TabPanel', {
    'TabPanel-active': active
  }, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    role: "tabpanel"
  }, children);
};
var _default = exports.default = TabPanel;